<script setup>
import { defineProps, defineEmits } from "vue";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import CuentaUsuario from "@/components/CuentaUsuario.vue";
import { useScreenStore } from "@/store/useScreenStore";

defineProps({
  visible: Boolean,
});
const emit = defineEmits(["update:visible"]);

const screen = useScreenStore();
</script>

<template>
  <Dialog
    :visible="visible"
    @update:visible="(v) => emit('update:visible', v)"
    modal
    header="Mi cuenta"
    :style="{ width: screen.isMobile ? '100%' : '460px' }"
  >
    <CuentaUsuario />
    <template #footer>
      <Button label="Cerrar" text @click="emit('update:visible', false)" />
    </template>
  </Dialog>
</template>
